export default __webpack_public_path__ + "images/9_2_image.jpg";